<template>
  <li class="participant-result lap" :class="`gen-${subject.gender}`" @click="handleClick" :style="rowStyle">
    <span class="bib"><span :style="bibStyle">{{ subject.bib }}</span></span>
    <span class="first-name" @click="$emit('click', $event)">{{ subject.lastName }}</span>
    <span class="last-name" @click="$emit('click', $event)">{{ subject.firstName }}</span>
    <span class="gender">{{ subject.gender }}</span>
    <span class="age">{{ age }}</span>
    <span v-if="subject.waveId" class="wave">W-{{ subject.waveId }}</span>
    <span class="race-name">{{ race.name }}</span>
    <span class="flexible-space" />
    <span class="status">{{ statusString }}</span>
  </li>
</template>

<style lang="scss">
.participant-result {
//  display: table-row;
  display: flex;
  flex-direction: row;
  line-height: 44px;
  cursor: pointer;
  user-select: none;
	
  background-image: linear-gradient(to right, var(--accent-color) -150%, var(--alternate-row-bgcolor) 100%); /* Set the background image with a gradient */
	background-repeat: no-repeat;
  background-size: calc(100% - 100% * var(--s)) 100%; /* Set the background size to 50% of the width and 100% of the height */
	background-position: 0 2px;
  
  &:hover {
    background: var(--row-hover-bgcolor);
  }

  &>span {
    vertical-align: middle;
    vertical-align: -webkit-baseline-middle;
    white-space: nowrap; text-overflow: ellipsis; overflow: hidden
  }
  
  .flexible-space {
    flex-grow: 1;
    flex-basis: 1px;
  }

  span:not(last-child) {
    margin-right: 8px;
  }
  
  .bib {
    width: 50px;
    text-align: center;

    span {
      color: var(--neg-color); 
      background: var(--neg-bgcolor); 
      padding: 2px;
      border-radius: 4px; 
      font-weight: bold; 
      min-width: 2em;
      display: inline-block;
      margin: 0 auto;
      line-height: 1.25em;
    }
  }
  
  .wave { width: 5ex; color: var(--text-dim1-color); }
  
  .first-name { width: 12ex; overflow: hidden; text-overflow: ellipsis; white-space:nowrap; }
  .last-name  { width: 15ex; overflow: hidden; text-overflow: ellipsis; white-space:nowrap; }

  &.gen-F .gender { width: 1.5ex; color: #ee0076; }
  &.gen-M .gender { width: 1.5ex; color: #1d606c; }
  
  .status {
    text-align:right;
  }
  
}
</style>

<script>
export default {
  props: {
    subject: {
      type: Object,
      required: true
    },
    score: {
      type: Number,
      required: false,
			default: 0,
    }
  },
  
  emits: ['click', 'resultClick'],
  
  computed: {
    race() { return this.subject.race },
    age() {
      const par = this.subject;
      if (par.age) return par.age;
      if (par.dob) {
        // calc age from birthday
        const diff = new Date().setHours(0) - new Date(par.dob);
        return new Date(diff).getUTCFullYear() - 1970;
      }
      return undefined;
    },
    
		rowStyle() {
			return `--s: ${this.score}`;
		},
		
    bibStyle() {
      return `border-top: 8px solid ${this.race.color}; padding-top: 0px`;
    },
    
    statusString() {
      switch (parseInt(this.subject.status))
      {
        case 0:
          if (!this.subject.st) 
            return 'Expected';
          if (this.subject.ft)
            return 'Finished';

          return 'Current';
        case 1: return 'DNS';
        case 2: return 'DNF';
        case 3: return 'DQ';
        case 4: return 'Unofficial';
        case 6: return 'Pending DNF';
        default:
          return this.subject.status;
      }
    }
  },
  
  methods: {
    handleClick() {
      this.$emit('resultClick', this.subject);
    }
  }
}
</script>
